import { render, staticRenderFns } from "./YapimAsamasinda.vue?vue&type=template&id=4db59e48&scoped=true&class=pa-0"
import script from "./YapimAsamasinda.vue?vue&type=script&lang=ts"
export * from "./YapimAsamasinda.vue?vue&type=script&lang=ts"
import style0 from "./YapimAsamasinda.vue?vue&type=style&index=0&id=4db59e48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db59e48",
  null
  
)

export default component.exports